export default "__VITE_ASSET__B_A57udK__"